app.controller('AccountDiscountController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.discount_groups = {
        "pronto": {"PRONTO DOOR": "PFIR", "PRONTO ACCESSORY": "PFIR"},
        "zurfiz": {"ZURFIZ DOOR": "DIZD", "ZURFIZ ACCESSORY": "DIZA"},
        "bella": {"BELLA DOOR": "DIDR", "BELLA ACCESSORY": "DIAC"},
        "valore": {"VALORE DOOR": "DIVD", "VALORE ACCESSORY": "DIVA"},
        "clicbox": {"CLICBOX": "CBIC"},
        "hettich": {"HETTICH": "HETT"},
        "handles": {"HANDLES": "DIHA"}
    };
}]);